import { useQuery } from "@tanstack/react-query";

import { quoteRequestTransportQuery } from "#modules/quoteRequests/infra/quoteRequestTransport.query";

export const useQuoteRequestTransport = (id: string | undefined) => {
  const { data, ...rest } = useQuery({ ...quoteRequestTransportQuery(id) });

  return { quoteRequestTransport: data, ...rest };
};
